import React, { useState, useEffect } from 'react';
import axios from 'axios';
import config from "../../config/default.json";
import { useTournament } from '../TournamentContext';

const base_url = config.base_url;

const ManageDivisions = () => {
  const { tournamentID } = useTournament();
  const [divisions, setDivisions] = useState([]);
  const [selectedDivisions, setSelectedDivisions] = useState([]);
  const [editData, setEditData] = useState({});
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (tournamentID) fetchDivisions();
  }, [tournamentID]);

  const fetchDivisions = async () => {
    try {
      const res = await axios.get(`${base_url}/api/divisions/${tournamentID}`);
      setDivisions(res.data);
    } catch (err) {
      console.error("Error fetching divisions", err);
    }
  };

  const handleSelect = (id) => {
    setSelectedDivisions(prev =>
      prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]
    );
  };

  const handleFieldChange = (id, field, value) => {
    setEditData(prev => ({
      ...prev,
      [id]: {
        ...prev[id],
        [field]: value,
      }
    }));
  };

  const handleUpdateSelected = async () => {
    try {
      for (let id of selectedDivisions) {
        if (editData[id]) {
          await axios.put(`${base_url}/api/${tournamentID}/divisions/${id}`, editData[id], {
            headers: { Authorization: `Bearer ${token}` }
          });
        }
      }
      fetchDivisions();
      setEditData({});
      setSelectedDivisions([]);
      alert("Selected divisions updated successfully");
    } catch (err) {
      console.error("Error updating divisions", err);
    }
  };

  const handleDeleteSelected = async () => {
    if (!window.confirm("Delete selected divisions?")) return;
    try {
      for (let id of selectedDivisions) {
        await axios.delete(`${base_url}/api/${tournamentID}/divisions/${id}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
      }
      fetchDivisions();
      setSelectedDivisions([]);
    } catch (err) {
      console.error("Error deleting divisions", err);
      alert("Error deleting Division." + ' ' + err.response?.data?.error || "" );

    }
  };

  return (
    <div>
      <h2>Manage Divisions</h2>
      <p>Check a division to enable editing or deleting.</p>
      <table border="1" cellPadding="5">
        <thead>
          <tr>
            <th>Select</th>
            <th>Name</th>
            <th>Description</th>
          </tr>
        </thead>
        <tbody>
          {divisions.map(div => (
            <tr key={div._id}>
              <td>
                <input
                  type="checkbox"
                  checked={selectedDivisions.includes(div._id)}
                  onChange={() => handleSelect(div._id)}
                />
              </td>
              <td>
                <input
                  type="text"
                  defaultValue={div.name}
                  disabled={!selectedDivisions.includes(div._id)}
                  onChange={(e) => handleFieldChange(div._id, "name", e.target.value)}
                />
              </td>
              <td>
                <input
                  type="text"
                  defaultValue={div.description}
                  disabled={!selectedDivisions.includes(div._id)}
                  onChange={(e) => handleFieldChange(div._id, "description", e.target.value)}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "15px" }}>
        <button onClick={handleUpdateSelected} disabled={!selectedDivisions.length}>
          Update Selected
        </button>
        &nbsp;
        <button onClick={handleDeleteSelected} disabled={!selectedDivisions.length}>
          Delete Selected
        </button>
      </div>
    </div>
  );
};

export default ManageDivisions;
